import { removeRedundantObjects } from 'utils/group';
import { listReconciliationProperties, listReconciliationPropertiesNext } from '../thunks/reconciliation-properties';
import { handlePending, handleRejected } from './utils';

export const reconciliationPropertiesReducers = (builder) => {
  // list reconciliation properties
  builder
    .addCase(listReconciliationProperties.fulfilled, (state, action) => {
      const { data, offset = 0 } = action.payload;

      const filters = { ...action.meta.arg };
      state.propertyFilters = { ...filters };
      delete filters.property_id;
      delete filters.un_reconciled;

      state.properties.value = data;
      state.properties.offset = offset;
      state.properties.hasMore = data.length > 0;
      state.properties.loading = false;
      state.propertyQuotes.value = {};
      state.quoteFilters = filters;
    })
    .addCase(listReconciliationProperties.pending, (state) => handlePending(state, 'properties'))
    .addCase(listReconciliationProperties.rejected, (state) => handleRejected(state, 'properties'));

  // list reconciliation properties next
  builder
    .addCase(listReconciliationPropertiesNext.fulfilled, (state, action) => {
      const { data, offset = 0 } = action.payload;

      const filteredItems = removeRedundantObjects({
        array: [...state.properties.value, ...data],
        property: 'id',
      });

      state.properties.value = filteredItems;
      state.properties.offset = offset;
      state.properties.hasMore = data.length > 0;
      state.properties.loading = false;
    })
    .addCase(listReconciliationPropertiesNext.pending, (state) => handlePending(state, 'properties'))
    .addCase(listReconciliationPropertiesNext.rejected, (state) => handleRejected(state, 'properties'));
};
